import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { withStyles } from "@material-ui/core/styles";
import NotificationContent from "./NotificationContent";
import { dispatch, connect } from "../recontext/store";

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit,
    marginTop: 70,
    maxWidth: 320,
    borderRadius: 8
  }
});

class Notification extends React.PureComponent {
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch("HIDE_NOTIFICATION");
  };

  render() {
    const { notification, classes } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={notification.visible}
        autoHideDuration={10000}
        onClose={this.handleClose}
      >
        <NotificationContent
          className={classes.margin}
          onClose={this.handleClose}
          variant={notification.type}
          message={notification.message}
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = state => ({
  notification: state.notification
});

export default connect(mapStateToProps)(withStyles(styles)(Notification));
